import React, { useState } from 'react';
import useLocalStorage from 'hooks/use-local-storage';
import { Typography, Box, Checkbox, FormControlLabel } from '@mui/material';
import CommonModal from 'pages/ShareYourLight/components/CommonModal';
import { trackMixpanelEvent } from 'utils/utilMethods';
import { MixpanelEventName } from 'utils/constants';
import Theme from 'theme';

const LOCALSTORAGE_KEY = 'lightInDarknessModalDismissed';

function LightInDarknessModalV2() {
  const [checked, setChecked] = useState(false);
  const [stored, setStored] = useLocalStorage(LOCALSTORAGE_KEY);

  const handleCheckbox = (e: React.ChangeEvent<HTMLInputElement>) => {
    trackMixpanelEvent(MixpanelEventName.SHAREYOURLIGHT_CONSENT_CHECKBOX_CLICKED, {
      checked: e.target.checked,
    });
    setChecked(e.target.checked);
    setStored(e.target.checked ? 'true' : 'false');
  };

  return (
    <CommonModal
      open={stored !== 'true'}
      onClose={() => null}
      showClose={false}
      paperSx={{ maxWidth: 540, background: 'rgba(23, 27, 38, 0.95)' }}
      title={(
        <Typography
          variant='h6'
          fontSize={20}
          sx={{ color: '#CCB385', fontWeight: 500, mb: 4, textAlign: 'center' }}
        >
          A light in the darkness
        </Typography>
)}
    >
      <Typography
        sx={{ color: '#BBBBBB', mb: 4, textAlign: 'center', fontSize: 16, mx: '10%' }}
        fontWeight={400}
      >
        In honor of Suicide Prevention Awareness Month,
        we’re inviting people to share messages of hope and
        support to remind others they are not alone, and that things can get better.
      </Typography>
      <Box sx={{ background: '#272936', borderRadius: 3, px: 3, py: 1.5, alignItems: 'center', display: 'flex', flexDirection: 'column' }}>
        <Typography sx={{ color: '#BBBBBB', fontSize: 14, mb: 2, textAlign: 'center' }}>
          You must be 18 or older to access and/or post.
        </Typography>
        <FormControlLabel
          control={(
            <Checkbox
              checked={checked}
              onChange={handleCheckbox}
              sx={{ color: Theme.custom.colors.lightTextSecondary }}
            />
          )}
          label={(
            <Typography sx={{ color: '#BBBBBB', fontSize: 14 }}>
              By checking this box, you confirm that you are at least 18 years old.
            </Typography>
          )}
          sx={{ display: 'flex', justifyContent: 'center', m: 0 }}
        />
      </Box>
    </CommonModal>
  );
}

export default LightInDarknessModalV2;
